import React from 'react';
import { CheckIcon, MinusIcon, PlusIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { brandName, differenceWith, differenceWithout, keepImprovising, price, useTheSystem } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-ink py-10 sm:py-14" aria-labelledby="final-cta-heading" data-id="element-70" data-mp="3vrktt7v3dt8m">
      <div className="mx-auto max-w-5xl px-6" data-id="element-71" data-mp="2y66q4ib2fw6h">
        <SectionHeading title={<span id="final-cta-heading" data-id="element-73" data-mp="333fckv38ymdj">Your next volleyball practice</span>} data-id="element-72" data-mp="333yitejjbmbq" />

        <div className="mt-10 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-74" data-mp="3831qz7uta8nx">
          <div className="rounded-3xl border border-line bg-navy p-6 sm:p-7" data-id="element-75" data-mp="381qn781d90wt">
            <h3 className="font-display text-2xl font-extrabold uppercase text-fg" data-id="element-76" data-mp="3cujotn1jft4o">
              You can keep improvising...
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-77" data-mp="2fcjl5z2pdt6t">
              {keepImprovising.map(item => <li key={item} className="flex items-start gap-2.5 leading-snug text-muted" data-id="element-78" data-mp="2kbmjl0o6h15t">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-79" data-mp="2dbgrh46x28j7" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border-2 border-accent/60 bg-panel p-6 sm:p-7" data-id="element-80" data-mp="23kvx5sy9zq63">
            <h3 className="font-display text-2xl font-extrabold uppercase text-accent" data-id="element-81" data-mp="1ym2m076gob93">
              Or use {brandName}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-82" data-mp="1ujfp3ruxo051">
              {useTheSystem.map(item => <li key={item} className="flex items-start gap-2.5 font-medium leading-snug text-fg" data-id="element-83" data-mp="1plml95h3ri7x">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-84" data-mp="1knus684q1q25" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-85" data-mp="3f0u3hp22jy3m">
          <h3 className="text-center font-display text-3xl font-extrabold uppercase leading-tight text-fg sm:text-4xl" data-id="element-86" data-mp="3a29d0hcmcssd">
            The difference
          </h3>
          <div className="mt-8 grid overflow-hidden rounded-3xl border border-line md:grid-cols-2" data-id="element-87" data-mp="18bino2bsi9us">
            <div className="bg-navy" data-id="element-88" data-mp="1d5efso5dh2i1">
              <p className="border-b border-line px-5 py-4 font-display text-lg font-bold uppercase tracking-wide text-muted sm:px-6" data-id="element-89" data-mp="yexingzrsyqy">
                Keep improvising
              </p>
              <ul className="divide-y divide-line" data-id="element-90" data-mp="13bnutt8gfa73">
                {differenceWithout.map(item => <li key={item} className="flex items-start gap-2 px-5 py-3.5 text-[0.95rem] leading-snug text-muted sm:px-6" data-id="element-91" data-mp="1r4e8c6w0a1jh">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-92" data-mp="1i2wp4fnaxjqk" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="border-t border-line bg-accent/[0.07] md:border-l md:border-t-0" data-id="element-93" data-mp="6nrcojxdc6tr">
              <p className="border-b border-line px-5 py-4 font-display text-lg font-bold uppercase tracking-wide text-accent sm:px-6" data-id="element-94" data-mp="apcv0kso9dbc">
                {brandName}
              </p>
              <ul className="divide-y divide-line" data-id="element-95" data-mp="37wu8ceca8wx">
                {differenceWith.map(item => <li key={item} className="flex items-start gap-2 px-5 py-3.5 text-[0.95rem] font-medium leading-snug text-fg sm:px-6" data-id="element-96" data-mp="3ublls3cwek3e">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-97" data-mp="84wzil3d77mz" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-98" data-mp="3bmeys452n6bs">
          <p className="text-lg italic text-muted sm:text-xl" data-id="element-99" data-mp="3qajfx3oh79sg">
            You do not need to be the perfect volleyball coach.
          </p>
          <p className="mx-auto mt-3 max-w-xl text-xl font-medium leading-snug text-fg sm:text-2xl" data-id="element-100" data-mp="3lirzhlz1akg1">
            You need a system that helps you{' '}
            <span className="font-bold text-accent" data-id="element-101" data-mp="2xrw3sdrgj53i">plan faster</span>, coach
            with <span className="font-bold text-accent" data-id="element-102" data-mp="2st1klapkveiv">more structure</span>,
            and give your players{' '}
            <span className="font-bold text-accent" data-id="element-103" data-mp="1w1xt4xjxasqq">more meaningful repetitions</span>.
          </p>

          <div className="mx-auto mt-8 grid max-w-md grid-cols-2 gap-2.5 text-left" data-id="element-104" data-mp="202zrlc60n0rn">
            <ul className="space-y-2 rounded-2xl bg-danger/[0.06] px-4 py-4" data-id="element-105" data-mp="252cgs3kd0jxe">
              {['Less searching.', 'Less waiting.', 'Less improvisation.'].map(line => <li key={line} className="flex items-start gap-2 text-[0.95rem] leading-snug text-muted" data-id="element-106" data-mp="2ev1nkl4yt9me">
                  <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger/70" strokeWidth={2.6} aria-hidden="true" data-id="element-107" data-mp="2jsaa0xx5bztg" />
                  {line}
                </li>)}
            </ul>
            <ul className="space-y-2 rounded-2xl bg-accent/10 px-4 py-4" data-id="element-108" data-mp="2sujhtg115f35">
              {['More structure.', 'More touches.', 'More coaching.'].map(line => <li key={line} className="flex items-start gap-2 text-[0.95rem] font-semibold leading-snug text-fg" data-id="element-109" data-mp="tiqhpaiy3tm7">
                  <PlusIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-110" data-mp="yi363zpgt8qw" />
                  {line}
                </li>)}
            </ul>
          </div>

          <p className="mt-10 font-display text-3xl font-extrabold uppercase leading-[0.95] text-accent sm:text-5xl" data-id="element-111" data-mp="m3o8v23zxlb4">
            Your next volleyball practice is already planned.
          </p>

          <CtaButton size="large" className="mt-9 w-full sm:w-auto" data-id="element-112" data-mp="c9eejevhucxr">
            Get {brandName} — {price}
          </CtaButton>
          <p className="mt-4 text-sm text-muted" data-id="element-113" data-mp="14w8wo54u9082">
            Secure payment · Instant access · 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}